import { getCurrentInstance, inject } from "vue";
import { generateUniqueId } from "../utils.mjs";
function injectWithSelf(key, defaultValue) {
  const vm = getCurrentInstance();
  return (vm == null ? void 0 : vm.provides[key]) || inject(key, defaultValue);
}
export {
  generateUniqueId,
  injectWithSelf
};
//# sourceMappingURL=utils.mjs.map
